import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faTrashCan } from "@fortawesome/pro-solid-svg-icons";
import { AdminListCard, type BatchAction } from "@components/CatalogIndex";
import { humanizeLookupValueType, type Lookup } from "./types";
import "./style.css";

export interface LookupsListProps {
  rows: Lookup[];
  selectedIds: string[];
  setSelectedIds: (ids: string[]) => void;
  onAdd: () => void;
  onEdit: (lookup: Lookup) => void;
  onBatchDelete: () => void;
  questionName: (slug: string) => string;
}

export const LookupsList = ({
  rows,
  selectedIds,
  setSelectedIds,
  onAdd,
  onEdit,
  onBatchDelete,
  questionName,
}: LookupsListProps): JSX.Element => {
  const toggle = (id: string) =>
    setSelectedIds(
      selectedIds.includes(id)
        ? selectedIds.filter((x) => x !== id)
        : [...selectedIds, id]
    );

  const batchActions: BatchAction[] = [
    {
      icon: faTrashCan,
      label: "Delete",
      onClick: onBatchDelete,
      variant: "danger",
    },
  ];

  return (
    <AdminListCard
      title="Survey Lookups"
      bare
      isEmpty={rows.length === 0}
      emptyMessage="No lookups yet."
      onNew={onAdd}
      newButtonLabel="Add Lookup"
      batchActions={batchActions}
      selectedCount={selectedIds.length}
    >
      <table className="lookups-table">
        <thead>
          <tr>
            <th className="select-col" />
            <th>Name</th>
            <th>Value Type</th>
            <th>Index 1</th>
            <th>Index 2</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((l) => (
            <tr key={l.id}>
              <td>
                <input
                  type="checkbox"
                  style={{ accentColor: "#418172" }}
                  aria-label={`Select lookup ${l.name}`}
                  checked={selectedIds.includes(l.id)}
                  onChange={() => toggle(l.id)}
                />
              </td>
              <td>
                <button
                  type="button"
                  className="adminListEditLink lookup-edit-link"
                  onClick={() => onEdit(l)}
                >
                  {l.name}
                  <FontAwesomeIcon
                    icon={faPencil}
                    className="adminListEditLink__icon"
                  />
                </button>
              </td>
              <td>{humanizeLookupValueType(l.valueType)}</td>
              <td>{l.index1 ? questionName(l.index1) : ""}</td>
              <td>{l.index2 ? questionName(l.index2) : "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </AdminListCard>
  );
};

export default LookupsList;
